import axios, { AxiosResponse } from 'axios';
import { Acreditado, AcreditadoTurno, Categoria, FranjaDisponible, TurnoDisponible } from './suite.interfaces';
import { CommonService } from './common.services';

export class TurnosService extends CommonService {
  
  async findCategoriasPadreBy(evento: number): Promise<Categoria[]> {
    try {
      const response: AxiosResponse<Categoria[]> = await axios.get(super.getServerUrl() + '/mobile/findCategoriasPadreBy?evento=' + evento, { headers: {"Authorization": this.token, "Client-ID" : this.clientId }});
      return response.data;
    } catch (error) {
      throw super.manageError(error);
    }
  }

  async findCategoriaBy(evento: number, categoria:number): Promise<Categoria> {
    try {
      const response: AxiosResponse<Categoria> = await axios.get(super.getServerUrl() + '/mobile/findCategoriaBy?evento=' + evento + '&categoria=' + categoria, { headers: {"Authorization": this.token, "Client-ID" : this.clientId }});
      return response.data;
    } catch (error) {
      throw super.manageError(error);
    }
  }

  async findCategoriasBy(evento: number, categoriaPadre:number): Promise<Categoria[]> {
    try {
      const response: AxiosResponse<Categoria[]> = await axios.get(super.getServerUrl() + '/mobile/findCategoriasBy?evento=' + evento + '&categoriaPadre=' + categoriaPadre, { headers: {"Authorization": this.token, "Client-ID" : this.clientId }});
      return response.data;
    } catch (error) {
      throw super.manageError(error);
    }
  }
	
  async findTurnosDisponiblesBy(evento: number): Promise<TurnoDisponible[]> {
    try {
      const response: AxiosResponse<TurnoDisponible[]> = await axios.get(super.getServerUrl() + '/mobile/findTurnosDisponiblesBy?evento=' + evento, { headers: {"Authorization": this.token, "Client-ID" : this.clientId }});
      return response.data;
    } catch (error) {
      throw super.manageError(error);
    }
  }
	
  async findTurnosDisponiblesByCategoria(evento: number, categoria: number): Promise<TurnoDisponible[]> {
    try {
      const response: AxiosResponse<TurnoDisponible[]> = await axios.get(super.getServerUrl() + '/mobile/findTurnosDisponiblesByCategoria?evento=' + evento + '&categoria=' + categoria, { headers: {"Authorization": this.token, "Client-ID" : this.clientId }});
      return response.data;
    } catch (error) {
      throw super.manageError(error);
    }
  }

  async findFranjasDisponiblesBy(evento: number, turnoDisponible: number): Promise<FranjaDisponible[]> {
    try {
      const response: AxiosResponse<FranjaDisponible[]> = await axios.get(super.getServerUrl() + '/mobile/findFranjasDisponiblesBy?evento=' + evento + '&turnoDisponible=' + turnoDisponible, { headers: {"Authorization": this.token, "Client-ID" : this.clientId }});
      return response.data;
    } catch (error) {
      throw super.manageError(error);
    }
  }

  async findAllFranjasBy(evento: number, turnoDisponible: number): Promise<FranjaDisponible[]> {
    try {
      const response: AxiosResponse<FranjaDisponible[]> = await axios.get(super.getServerUrl() + '/mobile/findAllFranjasBy?evento=' + evento + '&turnoDisponible=' + turnoDisponible, { headers: {"Authorization": this.token, "Client-ID" : this.clientId }});
      return response.data;
    } catch (error) {
      throw super.manageError(error);
    }
  }

  async asignarTurnoConDescripcion(evento: number, franjaDisponible:number, acreditado:Acreditado, descripcionFranja:string): Promise<String> {
    try {
      const response: AxiosResponse<String> = await axios.get(super.getServerUrl() + '/mobile/asignarTurnoConDescripcion?evento=' + evento + '&franjaDisponible=' + franjaDisponible + "&acreditado=" + acreditado.id + "&descripcionFranja=" + encodeURIComponent(descripcionFranja), { headers: {"Authorization": this.token, "Client-ID" : this.clientId }});
      return response.data;
    } catch (error) {
      throw super.manageError(error);
    }
  }

  async asignarTurnosCategorias(evento: number, acreditado: Acreditado, turnos: number[], cancelarTomados: boolean, verificarAcreditado: boolean): Promise<String> {
    try {
      let paramTurnos: string = '';
      for (var i = 0; i < turnos.length; i++) {
        paramTurnos += "&turnosSeleccionados=" + turnos[i];
      }
      const response: AxiosResponse<String> = await axios.get(super.getServerUrl() + '/mobile/asignarTurnosCategorias?evento=' + evento + '&acreditado=' + acreditado.id + "&cancelarTomados=" + cancelarTomados + "&verificarAcreditado=" + verificarAcreditado + paramTurnos, { headers: {"Authorization": this.token, "Client-ID" : this.clientId }});
      return response.data;
    } catch (error) {
      throw super.manageError(error);
    }
  }

  async asignarTurno(evento: number, franjaDisponible:number, acreditado:Acreditado): Promise<String> {
    try {
      const response: AxiosResponse<String> = await axios.get(super.getServerUrl() + '/mobile/asignarTurno?evento=' + evento + '&franjaDisponible=' + franjaDisponible + "&acreditado=" + acreditado.id, { headers: {"Authorization": this.token, "Client-ID" : this.clientId }});
      return response.data;
    } catch (error) {
      throw super.manageError(error);
    }
  }
	
  async cancelarTurno(evento: number, franjaDisponible:number, acreditado:Acreditado): Promise<string> {
    try {
      const response: AxiosResponse<string> = await axios.get(super.getServerUrl() + '/mobile/cancelarTurno?evento=' + evento + '&franjaDisponible=' + franjaDisponible + "&acreditado=" + acreditado.id, { headers: {"Authorization": this.token, "Client-ID" : this.clientId }});
      return response.data;
    } catch (error) {
      throw super.manageError(error);
    }
  }
	
  async findTurnosTomadosBy(evento: number, acreditado: Acreditado): Promise<AcreditadoTurno[]> {
    try {
      const response: AxiosResponse<AcreditadoTurno[]> = await axios.get(super.getServerUrl() + '/mobile/findTurnosTomadosBy?evento=' + evento + '&acreditado=' + acreditado.id, { headers: {"Authorization": this.token, "Client-ID" : this.clientId }});
      return response.data;
    } catch (error) {
      throw super.manageError(error);
    }
  }

  async findTurnoTomadosBy(evento: number, id: number): Promise<AcreditadoTurno[]> {
    try {
      const response: AxiosResponse<AcreditadoTurno[]> = await axios.get(super.getServerUrl() + '/mobile/findTurnoTomadosBy?evento=' + evento + '&id=' + id, { headers: {"Authorization": this.token, "Client-ID" : this.clientId }});
      return response.data;
    } catch (error) {
      throw super.manageError(error);
    }
  }
}

